import { useState, useEffect } from 'react';
import { Phone } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

const API = process.env.REACT_APP_BACKEND_URL;

export const FloatingCallWidget = () => {
  const { user } = useAuth();
  const [config, setConfig] = useState(null);

  useEffect(() => {
    if (!user) return;
    const token = localStorage.getItem('konnect_access_token');
    fetch(`${API}/api/voice/config`, { headers: token ? { 'Authorization': `Bearer ${token}` } : {} })
      .then(r => r.json())
      .then(d => setConfig(d))
      .catch(() => {});
  }, [user]);

  if (!config?.widget_enabled || !config?.tenant_slug) return null;

  const publicUrl = `${window.location.origin}/voice/${config.tenant_slug}`;

  return (
    <button
      onClick={() => window.open(publicUrl, '_blank')}
      className="fixed bottom-[4.25rem] right-4 md:bottom-6 md:right-6 z-40 w-14 h-14 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl hover:scale-105 active:scale-95 transition-all"
      style={{ backgroundColor: 'rgba(16, 185, 129, 0.65)' }}
      data-testid="floating-call-widget"
      title="Talk to our AI Receptionist"
    >
      <Phone className="h-6 w-6 text-white" />
    </button>
  );
};

export default FloatingCallWidget;
